/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import {
  BoundaryNodeDataCenter,
  BoundaryNodeDataCenter$inboundSchema,
  BoundaryNodeDataCenter$Outbound,
  BoundaryNodeDataCenter$outboundSchema,
} from "./boundarynodedatacenter.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type ListBoundaryNodeDataCentersResponse = {
  /**
   * List of Boundary Node Data Centers
   */
  data?: Array<BoundaryNodeDataCenter> | undefined;
};

/** @internal */
export const ListBoundaryNodeDataCentersResponse$inboundSchema: z.ZodType<
  ListBoundaryNodeDataCentersResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.array(BoundaryNodeDataCenter$inboundSchema).optional(),
});

/** @internal */
export type ListBoundaryNodeDataCentersResponse$Outbound = {
  data?: Array<BoundaryNodeDataCenter$Outbound> | undefined;
};

/** @internal */
export const ListBoundaryNodeDataCentersResponse$outboundSchema: z.ZodType<
  ListBoundaryNodeDataCentersResponse$Outbound,
  z.ZodTypeDef,
  ListBoundaryNodeDataCentersResponse
> = z.object({
  data: z.array(BoundaryNodeDataCenter$outboundSchema).optional(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListBoundaryNodeDataCentersResponse$ {
  /** @deprecated use `ListBoundaryNodeDataCentersResponse$inboundSchema` instead. */
  export const inboundSchema =
    ListBoundaryNodeDataCentersResponse$inboundSchema;
  /** @deprecated use `ListBoundaryNodeDataCentersResponse$outboundSchema` instead. */
  export const outboundSchema =
    ListBoundaryNodeDataCentersResponse$outboundSchema;
  /** @deprecated use `ListBoundaryNodeDataCentersResponse$Outbound` instead. */
  export type Outbound = ListBoundaryNodeDataCentersResponse$Outbound;
}

export function listBoundaryNodeDataCentersResponseToJSON(
  listBoundaryNodeDataCentersResponse: ListBoundaryNodeDataCentersResponse,
): string {
  return JSON.stringify(
    ListBoundaryNodeDataCentersResponse$outboundSchema.parse(
      listBoundaryNodeDataCentersResponse,
    ),
  );
}

export function listBoundaryNodeDataCentersResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListBoundaryNodeDataCentersResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListBoundaryNodeDataCentersResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListBoundaryNodeDataCentersResponse' from JSON`,
  );
}
